import React from 'react';
import { useTranslation } from 'react-i18next';

// Detailed GDPR information content extracted from ExternalUserForm
// Renders scrollable article sections.
const GDPRInfoContent = () => {
  const { t } = useTranslation();
  return (
    <article style={{ maxHeight: '60vh', overflow: 'auto', paddingBottom: 16 }}>
      <h3 style={{ marginTop: 0 }}>
        {t('Spracovanie osobných údajov registrovaného používateľa')}
      </h3>

      <h4>{t('Správca osobných údajov')}</h4>
      <p>
        {t(
          'Správcom osobných údajov je Fakulta riadenia a informatiky Žilinskej univerzity v Žiline (FRI UNIZA).',
        )}{' '}
        {t(
          'Kontaktné údaje na správcu a zodpovednú osobu (DPO) sú uvedené na webovom sídle FRI/UNIZA.',
        )}
      </p>

      <h4>{t('Účely spracúvania')}</h4>
      <ul>
        <li>
          {t('registrácia a správa používateľského účtu v moduloch FRI portálu')}
        </li>
        <li>
          {t(
            'komunikácia o kurzoch, seminároch, termínoch a súvisiacich zmenách (napr. zrušenie termínu)',
          )}
        </li>
        <li>
          {t(
            'zaistenie bezpečnosti systému a ochrany pred zneužitím (vrátane použitia služby reCAPTCHA)',
          )}
        </li>
      </ul>

      <h4>{t('Právny základ spracúvania')}</h4>
      <ul>
        <li>
          {t(
            'čl. 6 ods. 1 písm. b) GDPR – spracúvanie je nevyhnutné na plnenie zmluvy alebo na vykonanie opatrení prijatých pred uzatvorením zmluvy (poskytnutie služby portálu FRI)',
          )}
        </li>
        <li>
          {t(
            'čl. 6 ods. 1 písm. a) GDPR – súhlas dotknutej osoby (napr. dobrovoľne poskytnuté údaje ako telefónne číslo, odosielanie oznamov)',
          )}
        </li>
        <li>
          {t(
            'čl. 6 ods. 1 písm. f) GDPR – oprávnený záujem správcu na zaistení bezpečnosti, prevencie podvodov a zneužitia systému (vrátane reCAPTCHA)',
          )}
        </li>
      </ul>

      <h4>{t('Rozsah spracúvaných údajov')}</h4>
      <p>
        {t(
          'V rozsahu potrebnom na registráciu a využívanie služby: titul(y), meno, priezvisko, e‑mailová adresa, voliteľne telefónne číslo, prípadne priradené roly v systéme.',
        )}
      </p>

      <h4>{t('Príjemcovia alebo kategórie príjemcov')}</h4>
      <ul>
        <li>{t('lektori kurzov, seminárov a administrátori systému FRI.edu')}</li>
        <li>{t('poskytovatelia IT služieb v zmluvnom vzťahu so správcom')}</li>
        <li>
          {t(
            'spoločnosť Google LLC (reCAPTCHA) – na účely bezpečnostného overenia, viď nižšie)',
          )}
        </li>
      </ul>

      <h4>{t('Prenos do tretích krajín')}</h4>
      <p>
        {t(
          'Pri využití služby Google reCAPTCHA môže dochádzať k prenosu údajov do tretích krajín (USA). Spracúvanie sa riadi podmienkami spoločnosti Google a štandardnými zmluvnými doložkami.',
        )}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noreferrer"
        >
          {t('Zásady ochrany súkromia Google')}
        </a>{' '}
        {t('a')}{' '}
        <a
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noreferrer"
        >
          {t('Podmienky používania')}
        </a>
        .
      </p>

      <h4>{t('Doba uchovávania')}</h4>
      <p>
        {t(
          'Osobné údaje uchovávame po dobu trvania používateľského účtu a najviac po dobu nevyhnutnú na splnenie účelu a povinností vyplývajúcich z osobitných predpisov; pri odvolaní súhlasu alebo zrušení účtu budú údaje zlikvidované alebo anonymizované, ak ich ďalšie uchovávanie nevyžaduje zákon.',
        )}
      </p>

      <h4>{t('Práva dotknutej osoby')}</h4>
      <ul>
        <li>{t('právo na prístup k údajom')}</li>
        <li>{t('právo na opravu nepresných údajov')}</li>
        <li>
          {t(
            'právo na vymazanie („právo byť zabudnutý“) v zákonom stanovených prípadoch',
          )}
        </li>
        <li>{t('právo na obmedzenie spracúvania')}</li>
        <li>
          {t(
            'právo na prenosnosť údajov, ktoré ste nám poskytli a ktoré spracúvame na základe súhlasu alebo zmluvy',
          )}
        </li>
        <li>
          {t(
            'právo namietať proti spracúvaniu založenému na oprávnenom záujme',
          )}
        </li>
      </ul>

      <h4>{t('Odvolanie súhlasu')}</h4>
      <p>
        {t(
          'Súhlas so spracúvaním osobných údajov môžete kedykoľvek odvolať, bez vplyvu na zákonnosť spracúvania pred jeho odvolaním.',
        )}
      </p>

      <h4>{t('Automatizované individuálne rozhodovanie')}</h4>
      <p>
        {t(
          'Automatizované rozhodovanie ani profilovanie sa nevykonáva; výnimkou je bezpečnostné hodnotenie reCAPTCHA, ktoré slúži výlučne na prevenciu zneužitia.',
        )}
      </p>

      <h4>{t('Sťažnosť dozornému orgánu')}</h4>
      <p>
        {t(
          'Máte právo podať sťažnosť na Úrad na ochranu osobných údajov SR, ak sa domnievate, že spracúvanie vašich osobných údajov je v rozpore s GDPR.',
        )}
      </p>

      <p style={{ fontSize: 12, color: '#666' }}>
        {t(
          'Tento informačný text má všeobecný charakter. Konkrétne interné smernice FRI/UNIZA môžu obsahovať podrobnejšie pravidlá spracúvania.',
        )}
      </p>
    </article>
  );
};

export default GDPRInfoContent;
